export default {"src":"/_next/static/image/public/images/ic_phone_blue.80eb44384e1f537dfc951033c1980cfb.svg","height":36,"width":36};